<template>
    <div>
    <div>

      
      <div class="grid grid-cols-6 gap-6">
        <div class="col-span-6 border-gray-200 lg:pr-6 lg:border-r lg:col-span-2">
          <form v-on:submit.prevent="onSubmit">
          <div class="flex justify-between">
            <h3 class="text-lg font-medium leading-6 text-gray-900">Ordine dal tavolo</h3>
                    <span 
                    @click="toogle()"
                    :class="this.form.enable ? 'bg-indigo-600' : 'bg-gray-200'"
                    role="checkbox" 
                    tabindex="0" 
                    aria-checked="false" 
                    class="relative flex-shrink-0 inline-block h-6 transition-colors duration-200 ease-in-out bg-gray-200 border-2 border-transparent rounded-full cursor-pointer w-11 focus:outline-none focus:shadow-outline">
                      <!-- On: "translate-x-5", Off: "translate-x-0" -->
                      <span aria-hidden="true"  :class="this.form.enable ? 'translate-x-5' : 'translate-x-0'" class="inline-block w-5 h-5 transition duration-200 ease-in-out transform translate-x-0 bg-white rounded-full shadow"></span>
                    </span>
                </div>
                <p class="w-64 max-w-full mt-1 text-sm leading-5 text-gray-500">
                  Abilitando questa funzione i clienti presenti nel tuo locale potranno effettuare le proprie ordinazioni direttamente dal menu digitale comunicando il numero del tavolo. Troverai la lista degli ordini nell'apposita sezione 
                </p>
 
 
                </form>
          </div>
                
                <div class="col-span-6 lg:col-span-4">

                  <div class="flex flex-col">
                    <div class="py-2 -my-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                      <div class="inline-block min-w-full p-4 overflow-hidden align-middle border-b shadow sm:rounded-lg">
                        <form v-if="form.enable" v-on:submit.prevent="onSubmit">
                          <h3 class="text-base font-medium leading-6 text-gray-900 ">Password <span class="text-sm font-normal">(facoltativa)</span></h3>
                          <p class="mt-1 text-sm text-gray-700">
                          Puoi proteggere le ordinazioni impostando una password che verrà chiesta al cliente al momento dell'invio dell'ordine. E' consigliabile aggiornarla frequentemente.
                          </p>
  
                          <div>
                            <input
                              :class="formErrors['settings.password'] ? 'border-red-300' : ''"
                              v-model="form.settings.password"
                              class="block w-full px-3 py-2 mt-1 transition duration-150 ease-in-out border border-gray-300 rounded-md shadow-sm form-input sm:text-sm sm:leading-5"
                            />
                            <p class="mt-1 text-xs text-red-600" v-if="formErrors['settings.password']">
                                {{ formErrors['settings.password'][0] }}
                            </p>
                          </div>


                          <p class="mt-3 text-sm text-gray-700">I clienti, una volta selezionati i piatti dal menu digitale, potranno inviarti l'ordine direttamente in menuByte. Riceverai una email per segnalarti l'arrivo di una nuova ordinazione.</p>
                          <label
                              for="whatsapp"
                              class="block mt-2 text-sm font-medium leading-5 text-gray-700"
                              >Inserisci l'email sulla quale ricevere le notifiche <span class="text-sm font-normal">(facoltativa)</span></label
                            >
                            <div class="relative mt-1 rounded-md shadow-sm">
                              <div
                                class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none"
                              >
                                <svg
                                    class="w-5 h-5 text-gray-400"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884zM18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
                                      clip-rule="evenodd"
                                    />
                                  </svg>

                              </div>
                              <input
                                :class="formErrors['settings.email'] ? 'border-red-300' : ''"
                                v-model="form.settings.email"
                                name="email"
                                id="email"
                                class="block w-full pl-10 form-input sm:text-sm sm:leading-5"
                                placeholder="email@miolocale.xyz"
                              />
                            </div>
                            <p class="mt-1 text-xs text-red-600" v-if="formErrors['settings.email']">
                                {{ formErrors['settings.email'][0] }}
                            </p>
                          
                          <h3 class="mt-4 text-base font-medium leading-6 text-gray-900">Note per i clienti</h3>

                          <div>
                            <textarea
                              :class="formErrors['settings.notes'] ? 'border-red-300' : ''"
                              v-model="form.settings.notes"
                              placeholder="Inserisci qui eventuali informazioni che vuoi comunicare ai clienti in fase di ordinazione"
                              class="block w-full px-3 py-2 mt-1 transition duration-150 ease-in-out border border-gray-300 rounded-md shadow-sm form-input sm:text-sm sm:leading-5"
                            ></textarea>
                            <p class="mt-1 text-xs text-red-600" v-if="formErrors['settings.notes']">
                                {{ formErrors['settings.notes'][0] }}
                            </p>
                          </div>
                          <button
                            type="submit"
                            class="inline-flex justify-center px-4 py-2 mt-4 text-sm font-medium leading-5 text-white transition duration-150 ease-in-out bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700"
                          >Salva</button>

                        </form>
                      </div>
                    </div>
                  </div>
      
      </div></div>
    </div>

  </div>
</template>

<script>
import OrderSettings from "../apis/OrderSettings";

export default {
  data() {
    return {
      id: this.$route.params.id,
      tl:{},
      formErrors: {},
      form:{
        enable: false,
        settings: {
          notes: "",
          password: ""
        }
      }
    };
  },
  mounted() {
    OrderSettings.getTableSettings(this.id).then(response => {
      this.form = response.data;
    });
  },
  created(){
  },
  methods: {
    toogle(){
      this.form.enable = !this.form.enable;
      this.onSubmit();
    },

    onSubmit: function() {
 
        this.formErrors = {};
        this.$store.dispatch("updateSpinner", true);
        
        OrderSettings.updateTableSettings(this.id, this.form)
          .then(() => {
            this.$store.dispatch("updateSpinner", false);
            this.$store.dispatch("addNotification", {id: Math.floor(Math.random() * 100000), title : "Dati aggiornati", description:""});
        })
        .catch(error => {
          if (error.response.status === 422) {

            this.formErrors = error.response.data.errors;
            this.$store.dispatch("addNotification", {id: Math.floor(Math.random() * 100000), title : "Correggi gli errori", description: "", succes: false});
          }
          this.$store.dispatch("updateSpinner", false);
        });       
    }
  }
};
</script>
